import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';
import { IContractNavigationState } from 'v3/data/store/contractCard/types';

export const initialNavigationState: IContractNavigationState = {
  currentStep: ContractNavigationEnum.INITIAL,
};
